<div class="gl-dashboard__header">
  <div class="gl-dashboard__title">
    <span>{{ 'dashboard.widgets.hoursLearning' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.hoursLearningTooltip' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
  <lms-select-dashboard
    [selectionList]="filterList"
    [defaultFilter]="defaultFilter"
    (selectedFilter)="setFilter($event)"
  ></lms-select-dashboard>
</div>
<ul class="gl-dashboard__list">
  <li>
    <span>{{ 'dashboard.widgets.totalHours' | translate }}</span>
    <span class="value" *ngIf="trainingHours['totalPlayedSeconds'] | lmsCheckNoData; else NoTotalPlayedSeconds">{{
      trainingHours['totalPlayedSeconds'] | calcDivision : 3600 | number : '1.0-1'
    }}</span>
    <ng-template #NoTotalPlayedSeconds
      ><span class="value void">{{ 'dashboard.widgets.noData' | translate }}</span></ng-template
    >
  </li>
  <li>
    <span>{{ 'dashboard.widgets.activeStudents' | translate }}</span>
    <span
      class="value"
      *ngIf="trainingHours['playingStudentsAverageSeconds'] | lmsCheckNoData; else NoPlayingStudentsAverageSeconds"
      >{{ trainingHours['playingStudentsAverageSeconds'] | calcDivision : 3600 | number : '1.0-1' }}</span
    >
    <ng-template #NoPlayingStudentsAverageSeconds
      ><span class="value void">{{ 'dashboard.widgets.noData' | translate }}</span></ng-template
    >
  </li>
  <li>
    <span>{{ 'dashboard.widgets.totalStudents' | translate }}</span>
    <span
      class="value"
      *ngIf="trainingHours['totalStudentsAverageSeconds'] | lmsCheckNoData; else NoTotalStudentsAverageSeconds"
      >{{ trainingHours['totalStudentsAverageSeconds'] | calcDivision : 3600 | number : '1.0-1' }}</span
    >
    <ng-template #NoTotalStudentsAverageSeconds
      ><span class="value void">{{ 'dashboard.widgets.noData' | translate }}</span></ng-template
    >
  </li>
</ul>
